import { cx } from '@emotion/css';
import toast from 'react-hot-toast';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

const crossIcon = getDesignSystemIcon('icon-cross-16.svg');

interface ToastMessageTemplateProps {
  backgroundColorClass: string;
  closable?: boolean;
  icon: string;
  iconColorClass: string;
  id?: string;
  message: string;
  dataTestId?: string;
}

export const ToastMessageTemplate = ({
  backgroundColorClass,
  closable = true,
  icon,
  iconColorClass,
  id,
  message,
  dataTestId,
}: ToastMessageTemplateProps) => {
  return (
    <div
      className={cx(backgroundColorClass, 'flex max-w-[650px] px-6 py-4 stihl-text-body-default-bold')}
      style={{ boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.4), 0px 2px 8px rgba(0, 0, 0, 0.2)' }}
      data-testid={dataTestId}
    >
      <div className="mr-4">
        <svg className={cx('mt-0.5 h-4 w-4', iconColorClass)}>
          <use xlinkHref={`${icon}#img`} />
        </svg>
      </div>
      <div>{message}</div>
      {closable && (
        <div className="flex h-full items-center pl-4">
          <button type="button" onClick={() => toast.dismiss(id)}>
            <svg className="h-4 w-4 text-primary-black">
              <use xlinkHref={`${crossIcon}#img`} />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};
